<template>
  <div class="col-sm-12">
    <div class="row">
      <div class="col-sm-2 text-center">
       <span class="material-icons-outlined check-icon"> check_circle </span>
      </div>
      <div class="col-sm-10">
        <h4 class="text-primary">No Course Materials Required</h4>
        <div class="">
          <p>This course requires no purchased materials.</p>
        </div>
        <div class="form-group row">
        <div class="col-sm-2 pe-0 notes">
          <label class="fw-bold fst-italic">NOTES:&nbsp;</label>
        </div>
        
        <div class="col-sm-6 p-0" v-if="book.notes!=null" v-html="book.notes"></div>
        <div class="col-sm-6 p-0" v-else>
          <p class="fst-italic" >Not Available.</p>
        </div>
      </div>
        <!-- <div class="col-sm-6 p-0" v-else>
            <p class="">Not Available</p>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>




export default {
  name: "SelectionPending",
  props:{
    book:Object
  },
  mounted() {
    //console.log(this.book,"book in nomr")
  }
  
}

</script>

<style scoped>
.check-icon {
  font-size: 88px;
  color: #18A957;
}
.notes {
width: 71px;
}
</style>
